import { ComponentChildren } from 'preact';
import clsx from 'clsx';

import styles from './Link.module.scss';

interface LinkProps {
  /** The url to link to */
  url?: string;
  /** Makes the link open in new tab */
  external?: boolean;
  /** Removes default underline from the link */
  removeUnderline?: boolean;
  /** Makes the link color the same as the current text color and adds an underline */
  monochrome?: boolean;
  /** The content to display inside the link */
  children: ComponentChildren;
}

export function Link({
  url,
  children,
  external,
  removeUnderline,
  monochrome,
}: LinkProps) {
  const className = clsx(
    styles.Link,
    removeUnderline && styles.noUnderline,
    monochrome && styles.monochrome,
  );
  const target = external ? '_blank' : undefined;
  const rel = external ? 'noopener noreferrer' : undefined;

  return (
    <a href={url} rel={rel} target={target} className={className}>
      {children}
    </a>
  );
}
